/* eslint new-cap: 0 */
import jsPDF from 'jspdf';

const LEFT = 15;
const TOP = 20;
const CENTER = 85;
const LINE = 7;
const FONT_SIZE = {
  NORMAL: 13,
  LARGE: 26,
};

export function splitString(text, defaultText) {
  // split string into two lines to fit into columns
  // eg 'A really long descriptive name for my plan'
  // would output an array
  // ['A really long','descriptive name...']
  // defaultText returns the default description if no text is passed in
  if (!text && defaultText) {
    // return default description
    return defaultText;
  }
  const textArray = text.split(' ');
  while (textArray.length > 2) {
    if (textArray[0].length + textArray[1].length < 17) {
      textArray.splice(0, 2, textArray[0].concat([' '], textArray[1]));
    } else if (textArray[1].length + textArray[2].length < 17) {
      textArray.splice(1, 2, textArray[1].concat([' '], textArray[2]));
    } else {
      textArray[1] = `${textArray[1]}...`;
      textArray.splice(2);
    }
  }
  return textArray;
}

function formatCurrency(number) {
  return `$${parseFloat(Math.round(number * 100) / 100).toFixed(2)} USD`;
}

function beginPDFReceipt() {
  const doc = new jsPDF();

  const easypostLogo = 'data:image/jpeg;base64,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';

  doc.addImage(easypostLogo, 'JPEG', 150, 15, 54, 15);

  doc.setFontSize(FONT_SIZE.NORMAL);
  doc.text(LEFT, TOP + (LINE * 0), 'EasyPost');
  doc.text(LEFT, TOP + (LINE * 1), '417 Montgomery Street, 5th Floor');
  doc.text(LEFT, TOP + (LINE * 2), 'San Francisco, CA 94104');
  doc.text(LEFT, TOP + (LINE * 3), 'support@easypost.com');

  doc.setFontType('bold');
  doc.setFontSize(FONT_SIZE.LARGE);
  doc.text(CENTER, TOP + (LINE * 5), 'RECEIPT');

  return doc;
}

export function generatePaymentLogPDFReceipt(filename, data) {
  const doc = beginPDFReceipt();
  const planDescription = splitString(data.plan, ['Shipping API', 'Services']);
  const paymentMethod = splitString(data.paymentMethod);

  doc.setFontSize(FONT_SIZE.NORMAL);
  doc.text(LEFT, TOP + (LINE * 7), 'Account:');
  doc.text(LEFT, TOP + (LINE * 8), 'Name:');
  doc.text(LEFT, TOP + (LINE * 9), 'Date:');
  doc.text(LEFT, TOP + (LINE * 10), 'Total Amount:');
  doc.text(LEFT, TOP + (LINE * 11), 'Transaction ID:');

  const leftColWidth = LEFT + 60;
  doc.setFontType('normal');
  doc.text(leftColWidth, TOP + (LINE * 7), data.account);
  doc.text(leftColWidth, TOP + (LINE * 8), data.name);
  doc.text(leftColWidth, TOP + (LINE * 9), `${data.date} ${data.time} ${data.timezone}`);
  doc.text(leftColWidth, TOP + (LINE * 10), data.amount);
  doc.text(leftColWidth, TOP + (LINE * 11), data.transactionId);

  doc.setDrawColor(0);
  doc.setFillColor(239, 239, 239);
  const tableWidth = 168;
  doc.rect(LEFT, TOP + (LINE * 13), LEFT + tableWidth, (LINE * 2), 'FD');
  doc.rect(LEFT, TOP + (LINE * 15), LEFT + tableWidth, (LINE * 2), 'D');

  doc.setLineWidth(0.1);
  doc.setFontType('bold');

  const lineLeft = LEFT;
  const lineTop = TOP + (LINE * 13);
  const lineBottom = TOP + (LINE * 17);
  const dataTop = lineTop + (LINE * 3) - 1;

  const textLeft = 2;
  const textTop = lineTop + LINE - 1;

  const col1 = lineLeft;
  const col2 = col1 + 35;
  const col3 = col2 + 45;
  const col4 = col3 + 35;
  const col5 = col4 + 45;

  doc.line(col2, lineTop, col2, lineBottom);
  doc.line(col3, lineTop, col3, lineBottom);
  doc.line(col4, lineTop, col4, lineBottom);
  doc.line(col5, lineTop, col5, lineBottom);

  doc.text(col1 + textLeft, textTop, 'Date');
  doc.text(col2 + textLeft, textTop, 'Description');
  doc.text(col3 + textLeft, textTop, 'Payment');
  doc.text(col3 + textLeft, textTop + LINE - 1, 'Method');
  doc.text(col4 + textLeft, textTop, 'Payment Account');
  doc.text(col5 + textLeft, textTop, 'Amount');


  doc.setFontType('normal');
  doc.setFontSize(FONT_SIZE.NORMAL);
  doc.text(col1 + textLeft, dataTop, data.date);
  doc.text(col1 + textLeft, dataTop + LINE - 1, `${data.time} ${data.timezone}`);
  doc.text(col2 + textLeft, dataTop, planDescription[0]);
  doc.text(col2 + textLeft, dataTop + LINE - 1, planDescription[1]);
  doc.text(col3 + textLeft, dataTop, paymentMethod[0]);
  doc.text(col3 + textLeft, dataTop + LINE - 1, paymentMethod[1]);
  doc.text(col4 + textLeft, dataTop, `Ending in ${data.last4}`);
  doc.text(col5 + textLeft, dataTop, data.amount);

  doc.save(filename);
}

export function generateShipmentPDFReceipt(filename, origData) {
  const doc = beginPDFReceipt();

  const data = { ...origData };

  const feeSumFormatted = formatCurrency(
    (data.fees).reduce((fee1, fee2) => fee1 + Number(fee2.amount), 0)
  );

  doc.setFontSize(FONT_SIZE.NORMAL);
  doc.text(LEFT, TOP + (LINE * 7), 'Account:');
  doc.text(LEFT, TOP + (LINE * 8), 'Name:');
  doc.text(LEFT, TOP + (LINE * 9), 'Date:');
  doc.text(LEFT, TOP + (LINE * 10), 'Total Shipment Fees:');
  doc.text(LEFT, TOP + (LINE * 11), 'Shipment ID:');

  const leftColWidth = LEFT + 60;
  doc.setFontType('normal');
  doc.text(leftColWidth, TOP + (LINE * 7), data.account);
  doc.text(leftColWidth, TOP + (LINE * 8), data.name);
  doc.text(leftColWidth, TOP + (LINE * 9), `${data.date} ${data.time} ${data.timezone}`);
  doc.text(leftColWidth, TOP + (LINE * 10), feeSumFormatted);
  doc.text(leftColWidth, TOP + (LINE * 11), data.id);

  doc.setDrawColor(0);
  doc.setFillColor(239, 239, 239);

  const tableWidth = 168;
  const tableTop = TOP + (LINE * 13);
  const lineLeft = LEFT;
  const tbodyTop = 14;
  const tableBottom = TOP + (LINE * (tbodyTop + data.fees.length));

  /* thead tr */
  doc.rect(LEFT, TOP + (LINE * 13), LEFT + tableWidth, LINE, 'FD');

  /* tbody tr */
  data.fees.forEach((fee, idx) => {
    doc.rect(LEFT, TOP + (LINE * (tbodyTop + idx)), LEFT + tableWidth, LINE, 'D');
  });

  doc.setLineWidth(0.1);
  doc.setFontType('bold');

  const textLeft = 2;
  const thTop = tableTop + LINE - 2;

  const col1 = lineLeft;
  const col2 = col1 + 120;

  doc.line(col2, tableTop, col2, tableBottom);

  /* th */
  doc.text(col1 + textLeft, thTop, 'Description');
  doc.text(col2 + textLeft, thTop, 'Amount');

  /* td */
  doc.setFontType('normal');
  doc.setFontSize(FONT_SIZE.NORMAL);
  data.fees.forEach((fee, idx) => {
    const tdTop = TOP + (LINE * (tbodyTop + idx + 1)) - 2;
    doc.text(col1 + textLeft, tdTop, fee.type);
    doc.text(col2 + textLeft, tdTop, formatCurrency(fee.amount));
  });

  doc.save(filename);
}



// WEBPACK FOOTER //
// ./utils/receipt_pdf_generator.js